import { supabase } from "../../Services/supabaseClient";

export const getActivitiesByRecord = async (
  companyId,
  relatedType,
  relatedId
) => {
  const { data, error } = await supabase
    .from("crm_activities")
    .select("*")
    .eq("company_id", companyId)
    .eq("related_type", relatedType)
    .eq("related_id", relatedId)
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data || [];
};

export const createActivity = async (payload) => {
  const { data, error } = await supabase
    .from("crm_activities")
    .insert([payload])
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const completeActivity = async (activityId, companyId) => {
  const { data, error } = await supabase
    .from("crm_activities")
    .update({
      status: "completed",
      completed_at: new Date().toISOString(),
    })
    .eq("id", activityId)
    .eq("company_id", companyId)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const getMyOpenActivities = async (companyId, ownerId) => {
  const { data, error } = await supabase
    .from("crm_activities")
    .select("*")
    .eq("company_id", companyId)
    .eq("owner_id", ownerId)
    .eq("status", "open")
    .order("due_at", { ascending: true, nullsFirst: false });

  if (error) throw error;
  return data || [];
};
